import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {OmsService} from "../../services/oms-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class OmsOrderNotesPanelComponent implements IController {

  orderId: string;

  private notes: any;
  private note: any = {
    title: '',
    text: '',
    attachments: []
  }
  public isAddNoteSectionOpen: boolean = false;

  constructor(private $omsOrder, private commonsDialogService: CommonsDialogService, private commonsConstants,
              private $log, private omsService: OmsService, private commonsService: CommonsService) {
  }

  $onInit() {
    this.getOrderNotes()
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.orderId && !onChangesObj.orderId.isFirstChange()) {
      this.getOrderNotes();
    }
  }

  onAddAttachment() {
    this.commonsService.fileUpload(this.commonsConstants.fileConstants.upload.images)
      .then((result) => {
        this.afterUpload(result);
      })
      .catch(() => {
        this.$log.info('Closed File Upload')
      })
  }

  toggleAddNoteSection(){
    this.isAddNoteSectionOpen = !this.isAddNoteSectionOpen
  }

  onRemoveAttachment(index) {
    this.note.attachments.splice(index, 1);
  }

  onAttachmentMouseEnter(index) {
    this.note.attachments[index].canRemove = true
  }

  onAttachmentMouseLeave(index) {
    this.note.attachments[index].canRemove = false
  }

  onSubmit(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        _.forEach(this.note.attachments, attachment => {
          _.unset(attachment, 'canRemove')
        })
        this.addNote(form);
      }
    }
  }

  private getOrderNotes() {
    if (this.orderId) {
      this.$omsOrder().$asyncValues([this.orderId]).then(orders => {
        this.notes = orders[0].internalNotes
      })
    }
  }

  private afterUpload(uploadedResult) {
    const imageUrl = _.get(uploadedResult, 'url'),
      mimeType = _.get(uploadedResult, 'contentType');

    if (imageUrl) {
      const attachment = {
        url: imageUrl,
        mimeType: mimeType,
        canRemove: false
      };
      this.note.attachments.push(attachment);
    }
  }

  private addNote(form) {
    this.omsService.addNote(this.orderId, this.note)
      .then((res: any) => {
        this.notes = res.internalNotes;
        this.note = {
          title: '',
          text: '',
          attachments: []
        }
        form.$setPristine();
        form.$setUntouched();
      })
      .catch((error) => {
        this.$log.error('Failed to add note to order', error);
      })
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderNotesPanel', {
    bindings: {
      orderId: '<',
    },
    template: require('./oms-order-notes-panel.html').default,
    controller: OmsOrderNotesPanelComponent
  });
